// Shared formatting + banding for the Client Performance reports.

export const money = (n) => {
  if (n === null || n === undefined) return '—';
  const abs = Math.abs(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${n < 0 ? '-' : ''}$${abs}`;
};

export const money0 = (n) => {
  if (n === null || n === undefined) return '—';
  return `${n < 0 ? '-' : ''}$${Math.abs(Math.round(n)).toLocaleString()}`;
};

export const pct = (n) => (n === null || n === undefined ? '—' : `${Number(n).toFixed(1)}%`);

export const units = (n) => (n === null || n === undefined ? '—' : Number(n).toLocaleString());

export const pts = (n) => {
  if (n === null || n === undefined) return null;
  return `${n > 0 ? '+' : ''}${Number(n).toFixed(1)} pts`;
};

export const BANDS = {
  healthy: { label: 'Healthy', chip: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  watch: { label: 'Watch', chip: 'bg-amber-100 text-amber-800 border-amber-200' },
  at_risk: { label: 'At risk', chip: 'bg-rose-100 text-rose-800 border-rose-200' },
};

export const RECOMMENDATIONS = {
  keep_on_gr: { label: 'Keep on Guaranteed Returns', chip: 'bg-emerald-100 text-emerald-800' },
  keep: { label: 'Keep on current terms', chip: 'bg-emerald-100 text-emerald-800' },
  review_terms: { label: 'Review terms', chip: 'bg-amber-100 text-amber-800' },
  move_to_traditional: { label: 'Move to traditional wholesale', chip: 'bg-orange-100 text-orange-800' },
  review_for_offboarding: { label: 'Review for offboarding', chip: 'bg-rose-100 text-rose-800' },
  insufficient_data: { label: 'Not enough volume to judge', chip: 'bg-gray-100 text-gray-700' },
};

export const isoDay = (d) => {
  const copy = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return copy.toISOString().slice(0, 10);
};

const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);

export const DATE_PRESETS = [
  {
    key: 'this_month',
    label: 'This month',
    range: () => {
      const now = new Date();
      return { start: isoDay(startOfMonth(now)), end: isoDay(now) };
    },
  },
  {
    key: 'last_month',
    label: 'Last month',
    range: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0);
      return { start: isoDay(start), end: isoDay(end) };
    },
  },
  {
    key: 'last_90',
    label: 'Last 90 days',
    range: () => {
      const now = new Date();
      const start = new Date(now.getTime() - 89 * 86400000);
      return { start: isoDay(start), end: isoDay(now) };
    },
  },
  {
    key: 'this_year',
    label: 'This year',
    range: () => {
      const now = new Date();
      return { start: isoDay(new Date(now.getFullYear(), 0, 1)), end: isoDay(now) };
    },
  },
  {
    key: 'last_year',
    label: 'Last year',
    range: () => {
      const year = new Date().getFullYear() - 1;
      return { start: `${year}-01-01`, end: `${year}-12-31` };
    },
  },
  { key: 'custom', label: 'Custom range', range: null },
];

export const WEEKDAYS = [
  { value: '0', label: 'Monday' },
  { value: '1', label: 'Tuesday' },
  { value: '2', label: 'Wednesday' },
  { value: '3', label: 'Thursday' },
  { value: '4', label: 'Friday' },
  { value: '5', label: 'Saturday' },
  { value: '6', label: 'Sunday' },
];

export const SERIES_COLORS = [
  '#d97706', '#0ea5e9', '#7c3aed', '#059669', '#e11d48', '#475569',
];

// Query params the backend expects, built from the filter state.
export const toParams = (f) => {
  const p = { start: f.start, end: f.end };
  if (f.clientIds?.length) p.client_ids = f.clientIds.join(',');
  if (f.productIds?.length) p.product_ids = f.productIds.join(',');
  if (f.categories?.length) p.categories = f.categories.join(',');
  if (f.weekday !== '' && f.weekday !== null && f.weekday !== undefined) p.weekday = f.weekday;
  if (f.segment && f.segment !== 'all') p.segment = f.segment;
  if (f.tierId) p.tier_id = f.tierId;
  if (f.granularity) p.granularity = f.granularity;
  return p;
};
